import React from 'react';
import { useNavigate } from 'react-router';

import LazyImg from '~/components/lazy-img';
import Button from '~/components/button';
import { newLawnRoute } from '~/routes';

import styles from '~/components/sunday-store/components/product-details/custom-yarn-plan-cta.module.scss';

const CustomYarnPlanCTA = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.customYarnPlanCtaWrapper}>
      <LazyImg
        src="/images/my-yard-plan.svg"
        alt="My Yard Plan"
        height="95"
        width="78"
        className={styles.customYarnPlanCtaImage}
      />
      <div className={styles.customYarnPlanCtaCopy}>
        <h3>Wondering what your lawn really needs?</h3>
        <p>Let's create a custom plan for you.</p>
        <Button
          variant="transparentGreen"
          onClick={() => navigate(newLawnRoute())}
          className={styles.customYarnPlanCtaButton}
        >
          Start your lawn analysis
        </Button>
      </div>
    </div>
  );
};

export default CustomYarnPlanCTA;
